(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('StatusAlumnoPlanDeEstudiosDialogController', StatusAlumnoPlanDeEstudiosDialogController);

    StatusAlumnoPlanDeEstudiosDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'StatusAlumnoPlanDeEstudios'];

    function StatusAlumnoPlanDeEstudiosDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, StatusAlumnoPlanDeEstudios) {
        var vm = this;

        vm.statusAlumnoPlanDeEstudios = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.statusAlumnoPlanDeEstudios.id !== null) {
                StatusAlumnoPlanDeEstudios.update(vm.statusAlumnoPlanDeEstudios, onSaveSuccess, onSaveError);
            } else {
                StatusAlumnoPlanDeEstudios.save(vm.statusAlumnoPlanDeEstudios, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:statusAlumnoPlanDeEstudiosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
